import React from 'react';
import { connect } from 'react-redux';
import * as css from 'styles'
import styled from 'react-emotion'
import propStyles from 'prop-styles'

import content from '../data/content.json'
import titleFromSlug from 'utils/titleFromSlug'

import { Grid, Col } from 'components/Grid'
import Meta from 'components/Meta/Meta';
import View from 'components/View/View';
import Text from 'components/Text/Text';
import Link from 'components/Link/Link';
import FadeIn from '../components/Animated/FadeIn';

import Nav from 'containers/Nav';
import NavPopup from 'containers/NavPopup';
import Home from './Home';
import NotFound from './NotFound';

import Projects from './Projects';
import Project from './Project';
import Page from './Page';
import Ticker from './Ticker';
import Icon from './Icon';

const DesktopNavContainer = styled(Nav)({
  padding: '1.25em 2em',
  display: 'grid',
  gridTemplateColumns: '1fr 2fr 1fr',
  [css.breakpoint.m_down]: {
    display: 'none',
  },
  '& div':{
    transition: css.transition.fast,
    opacity: 1,
  },
},propStyles({
  scrolling: {
    '& div:first-child, & div:last-child': {
      opacity: 0,
    }
  }
}))

class DesktopNav extends React.PureComponent {

  state = {
    scrolling: false,
  }
  
  componentDidMount() {
    this.scrollWatcher()
  }

  scrollWatcher = () => {
    window.addEventListener('scroll', (e) => {
      // console.log(window.scrollY, this.state);
      if (window.scrollY > 10) {
        (this.state.scrolling === false) && this.setState({ scrolling: true })
      } else {
        (this.state.scrolling === true) && this.setState({ scrolling: false })
      }
    })
  }
  
  render() {
    return (
      <DesktopNavContainer scrolling={this.state.scrolling}>{this.props.children}</DesktopNavContainer>
    )
  }
}

const MobileNav = styled(Nav)({
  // padding: '1.5em 1em 0em 1em',
  padding: '1.25em 1em 0',
  display: 'grid',
  gridTemplateColumns: '7fr 1fr',
  [css.breakpoint.l_up]: {
    display: 'none',
  },
})

const Container = styled('div')({
  padding: '0.75em 2em',
  margin: '0 auto',
  maxWidth: '1600px',
  transition: css.transition.norm,

  [css.breakpoint.m_down]:{
    padding: '0.75em 1em 1em',
  },
})

const App = ({ location, slug, project, projectstatus, openModal, filter, navOpen }) => (
  <FadeIn>
  <Container style={{
    // color: location === 'route/page' ? css.color.white : css.color.black,
    // backgroundColor: location === 'route/page' ? css.color.black : css.color.white,
  }}>

    <Meta defaults />

    <NavPopup/>

    <DesktopNav>
      <View>
        <Link to="/"><FadeIn left key="title">GET IT Productions</FadeIn></Link>
        {/* {(location === 'route/home' || location === 'route/projects' || location === 'route/category') && <FadeIn left key="title">GET IT Productions</FadeIn> }  */}
        {/* {location==='route/project' && <FadeIn right key="back"><Link to="/"><Icon type="triangle" style={{marginRight: '0.5em'}} />Projects</Link></FadeIn>} */}
        {/* {location === 'route/page' && <FadeIn right key="back"><Link to="/"><Icon type="triangle" color={css.color.white} style={{ marginRight: '0.5em' }} /><span style={{ color: css.color.white }}>Projects</span></Link></FadeIn>} */}
      </View>

      <View style={{textAlign: 'center'}}>
        {/*  || location === 'route/page' */}
        {(location === 'route/home' || location === 'route/projects') && <FadeIn key="all"><Link to="" onClick={() => openModal('filters')} preventDefault><Icon type="triangle" rotate={navOpen ? -180 : -90} style={{ marginRight: '0.5em' }} />{filter || 'Highlights'}</Link></FadeIn>}
        {location === 'route/category' && <FadeIn key="all"><Link onClick={() => openModal('filters')} preventDefault><Icon type="triangle" rotate={navOpen ? -180 : -90} style={{ marginRight: '0.5em' }} />{titleFromSlug(slug)}</Link></FadeIn>}
        {location === 'route/project' && projectstatus === 'Success' && <FadeIn key="single"><Icon type="circle" style={{marginRight: '0.5em'}} /><span dangerouslySetInnerHTML={{__html:project.title.rendered}}/></FadeIn>}
      </View>

      <View style={{ textAlign: 'right' }}>
        <View style={{ position: 'relative', right: '-0.5rem', }}>
          {slug !== 'about' && <FadeIn><Link to="/about">About</Link></FadeIn>}
          {slug === 'about' && <FadeIn right><Link to="/">Close</Link></FadeIn>}
        </View>
      </View>
    </DesktopNav>

    <MobileNav>
      <View>
        {(location === 'route/home' || location === 'route/projects') && <FadeIn left key="title">{filter || 'GET IT Productions'}</FadeIn>} 
        {location === 'route/category' && <FadeIn left key="title">{titleFromSlug(slug)}</FadeIn>} 
        {location === 'route/project' && projectstatus === 'Success' && <FadeIn right key="single"><Icon type="circle" style={{ marginRight: '0.5em' }} /><span dangerouslySetInnerHTML={{ __html: project.title.rendered }} /></FadeIn>}
      </View>

      <View style={{ textAlign: 'right' }}>
          <Link to="/" onClick={() => openModal('filters')} preventDefault><Icon type="triangle" rotate={navOpen ? 0 : -90} 
            // color={location === 'route/page' ? css.color.white : css.color.black} 
            style={{ height: '0.9em', position: 'relative', right: '-0.5rem', }}/></Link>
      </View>
    </MobileNav>

    <View padding="3em 0 0 0"/> 

    {location==='route/home' && <Home content={content.pages.home}/>}
    {location==='route/category' && <Projects/>}
    {location==='route/projects' && <Projects/>}
    {location==='route/project' && <Project/>}
    {location==='route/page' && <Page/>}
    {location==='not-found' && <NotFound/>}

  </Container>
  </FadeIn>
);

const mapState = state => ({
  location: state.location.type,
  slug: state.location.payload.id,
  kind: state.location.kind,
  project: state.project.data[0],
  projectstatus: state.project.status,
  filter: state.location.query && state.location.query.filter,
  navOpen: state.modals.filters && state.modals.filters.open,
  // cartItems: Object.keys(state.cart.items).reduce((total, item) => total+state.cart.items[item], 0),
})

const mapDispatch = dispatch => ({
  openModal: (name) => dispatch.modals.open({ name }),
})

export default connect(mapState, mapDispatch)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js